export default function InputError(props) {

    return <>
        <p className={`text-red-500 ${props.className}`} style={{ fontSize: `${props.size}px` }}>
            {props.message}
        </p>
    </>
}